var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWelcomeCheckGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0039 8.04305C22.0547 8.04305 7.50391 22.6284 7.50391 40.6202C7.50391 58.6121 22.0547 73.1974 40.0039 73.1974C57.9532 73.1974 72.5039 58.6121 72.5039 40.6202C72.5039 35.8149 71.466 31.2526 69.6025 27.1463L40.107 55.6974L39.8688 55.4502L22.7407 37.6799L28.1358 32.4576L40.2701 45.0886L65.6118 20.5582C59.663 12.9396 50.4039 8.04305 40.0039 8.04305ZM40 80.7125C17.9086 80.7125 0 62.7613 0 40.6175C0 18.4736 17.9086 0.522461 40 0.522461C62.0914 0.522461 80 18.4736 80 40.6175C80 62.7613 62.0914 80.7125 40 80.7125Z",
    fill: "#5AB52F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeCheckGreen);
export default __webpack_public_path__ + "static/media/WelcomeCheckGreen.c75e11e1e59bb2c2166ff99b434d9fb6.svg";
export { ForwardRef as ReactComponent };